import { Box, Button, Heading, Text } from '@wix/design-system';
import s from './domainRegister.module.scss';
import React from 'react';
export const DomainRegisterWidget = _ref => {
  let {
    data,
    context
  } = _ref;
  const {
    domainName,
    siteGuid
  } = data;
  const {
    onWidgetAction
  } = context;
  const handleWidgetAction = (action, url) => {
    if (onWidgetAction) {
      onWidgetAction(DOMAIN_REGISTER, {
        action,
        value: url
      });
    }
  };

  // throw new Error('Not implemented');

  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    gap: 2
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    className: s.container
  }, /*#__PURE__*/React.createElement(Box, {
    gap: 1,
    className: s.illustration
  }, /*#__PURE__*/React.createElement("svg", {
    width: "60",
    height: "60",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5202 53.049L32.9344 54.4632L28.8332 58.5644L27.419 57.1502L31.5202 53.049ZM29.9996 11.6306C40.1451 11.6306 48.3696 19.8552 48.3696 30.0006C48.3696 40.1461 40.1451 48.3706 29.9996 48.3706C19.8542 48.3706 11.6296 40.1461 11.6296 30.0006C11.6296 19.8552 19.8542 11.6306 29.9996 11.6306ZM5.42348 33.3133L6.8377 34.7275L2.73648 38.8287L1.32227 37.4145L5.42348 33.3133ZM55.5196 29.0906C56.453 29.0906 57.2096 29.8473 57.2096 30.7806C57.2096 31.714 56.453 32.4706 55.5196 32.4706C54.5863 32.4706 53.8296 31.714 53.8296 30.7806C53.8296 29.8473 54.5863 29.0906 55.5196 29.0906ZM28.3482 1.88281L32.4494 5.98403L31.0352 7.39825L26.934 3.29703L28.3482 1.88281Z",
    fill: "#116DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7901 38.9605L20.3701 31.5405L22.4901 29.4105L27.7901 34.7205L38.7701 23.7305L40.8901 25.8605L27.7901 38.9605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5738 39.1878L58.675 43.289L57.2608 44.7032L53.1596 40.602L54.5738 39.1878ZM56.2698 10.7109L54.9398 15.6709L51.3098 12.0409L56.2698 10.7109ZM10.2998 6.88086L15.2598 8.21086L11.6298 11.8409L10.2998 6.88086Z",
    fill: "#28BF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0996 51.1902C44.0329 51.1902 44.7896 51.9469 44.7896 52.8802C44.7896 53.8136 44.0329 54.5702 43.0996 54.5702C42.1662 54.5702 41.4096 53.8136 41.4096 52.8802C41.4096 51.9469 42.1662 51.1902 43.0996 51.1902ZM6.79957 45.6302L11.7596 46.9502L8.12957 50.5902L6.79957 45.6302ZM6.99957 16.3102C7.93293 16.3102 8.68957 17.0669 8.68957 18.0002C8.68957 18.9336 7.93293 19.6902 6.99957 19.6902C6.06621 19.6902 5.30957 18.9336 5.30957 18.0002C5.30957 17.0669 6.06621 16.3102 6.99957 16.3102ZM41.2496 1.99023C42.1829 1.99023 42.9396 2.74687 42.9396 3.68023C42.9396 4.6136 42.1829 5.37023 41.2496 5.37023C40.3162 5.37023 39.5596 4.6136 39.5596 3.68023C39.5596 2.74687 40.3162 1.99023 41.2496 1.99023Z",
    fill: "#FFD527"
  }))), /*#__PURE__*/React.createElement(Box, {
    gap: 1,
    className: s.domainName
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "tiny"
  }, domainName)), /*#__PURE__*/React.createElement(Box, {
    height: "18px"
  }), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, "This domain is almost yours!"), /*#__PURE__*/React.createElement(Box, {
    height: "8px"
  }), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, "Get it now or upgrade to a yearly plan to get it for FREE"), /*#__PURE__*/React.createElement(Box, {
    height: "18px"
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "10px"
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: false,
    size: "small",
    skin: "premium",
    priority: "primary",
    onClick: () => {
      const url = `https://manage.wix.com/wix/api/premiumStart?${siteGuid ? 'siteGuid=' + siteGuid + '&' : ''}referralAdditionalInfo=domain-ai-assistant&domainName=${domainName}`;
      handleWidgetAction('upgrade_plan', url);
      window.open(url);
    },
    style: {
      width: '150px',
      margin: 'auto'
    }
  }, "Upgrade Plan", /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 5
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "11",
    height: "8",
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7071 4.00037L7.35037 7.35225C7.15682 7.54541 6.84338 7.54525 6.65002 7.3519C6.45663 7.15851 6.45639 6.84504 6.64948 6.65136L8.79289 4.50037H0.5V3.50037H8.79289L6.64948 1.34957C6.45639 1.15588 6.45663 0.842415 6.65002 0.649028C6.84338 0.455671 7.15682 0.455512 7.35037 0.648673L10.7071 4.00037Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement(Button, {
    fullWidth: false,
    size: "small",
    skin: "standard",
    priority: "secondary",
    onClick: () => {
      const url = `https://manage.wix.com/get-domain?domainName=${domainName}&flowType=purchase&referralAdditionalInfo=domain-ai-assistant&noHeader=true`;
      handleWidgetAction('buy_domain', url);
      window.open(url);
    },
    style: {
      width: '130px',
      margin: 'auto'
    }
  }, "Buy Domain")), /*#__PURE__*/React.createElement(Box, {
    height: "18px"
  }), /*#__PURE__*/React.createElement(Box, {
    className: s.bottomText
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    skin: "disabled"
  }, "A plan upgrade is required to connect your domain to your site")), /*#__PURE__*/React.createElement(Box, {
    height: "8px"
  })));
};
export const DOMAIN_REGISTER = 'DOMAIN_REGISTER';

// MESSAGE:
// <<{"widget": "DOMAIN_REGISTER", "data": {"domainName": "mydomain.com"}}>>
//# sourceMappingURL=domainRegister.js.map